import React, { useState } from "react";
import { useAppContext } from "../../../../../hooks/useAppContext";
import { Tag } from "lucide-react";
import { EDSButton } from "../../../../eds/EDSButton";
import { useCustomerContext } from "../../../../../hooks/useCustomerContext";
import LabelList from "./LabelList";
import { CustomerLabel } from "../../../../../types/VenueGroup";
import ManageLabelsModal from "./ManageLabels/ManageLabelsModal";
import { useDiaryContext } from "../../../../../hooks/useDiaryContext";
import {
  getSelectedBookingLabels,
  getSelectedCustomerLabels
} from "./BookingLabels";

const SelectedBookingLabels = () => {
  const { selectedBooking, venueConfig } = useDiaryContext();
  const [showManageLabels, setShowManageLabels] = useState<boolean>(false);
  const { venueGroupConfig } = useAppContext();
  const { selectedCustomer } = useCustomerContext();
  if (!selectedBooking || !venueConfig || !venueGroupConfig) {
    return null;
  }

  const loading =
    (selectedBooking.customerId && !selectedCustomer) ||
    selectedBooking.customerId !== selectedCustomer?.id;

  let customerLabels: CustomerLabel[] = [];

  if (selectedCustomer?.id === selectedBooking.customerId) {
    customerLabels =
      (selectedCustomer &&
        getSelectedCustomerLabels({
          venueConfig,
          venueGroupConfig,
          selectedCustomer
        })) ??
      [];
  }

  const bookingLabels = getSelectedBookingLabels({
    venueConfig,
    venueGroupConfig,
    selectedBooking
  });

  return (
    <>
      {showManageLabels && (
        <ManageLabelsModal
          selectedBooking={selectedBooking}
          selectedCustomer={selectedCustomer}
          handleClose={() => setShowManageLabels(false)}
        />
      )}
      <div className="SelectedBookingLabelsContainer mt-[7px] ml-4 flex">
        <EDSButton
          variant="outline"
          size="md"
          className="BookingLabelButton w-12 h-14 flex items-center justify-center p-2"
          onClick={() => {
            setShowManageLabels(true);
          }}
        >
          <div className="BookingLabelIconContainer flex flex-col items-center gap-1">
            <Tag size={18} strokeWidth={2} />
            <span className="BookingLabelCount text-sm font-medium leading-none text-current">
              {`(${
                (bookingLabels?.length ?? 0) + (customerLabels?.length ?? 0)
              })`}
            </span>
          </div>
        </EDSButton>
        <div className="SelectedBookingLabels ml-[18px] w-full pr-[15px]">
          <div className="BookingLabelsScrollContainer text-[13px] flex flex-row flex-[1_100%] overflow-hidden overscroll-none items-start gap-2">
            <div className="BookingLabels flex flex-nowrap overflow-x-auto flex-[1_1_100%] overscroll-none w-0 mt-px gap-2">
              <LabelList
                data={bookingLabels}
                noRecords="No booking labels found."
              />
            </div>
          </div>
          <div className="BookingLabelsScrollContainer text-[13px] flex flex-row flex-[1_100%] overflow-hidden overscroll-none items-start gap-2">
            <div className="CustomerLabels flex flex-nowrap overflow-x-auto flex-[1_1_100%] overscroll-none w-0 mt-3 gap-2">
              {loading ? (
                <div className="labelsLoading flex gap-2">
                  <LabelList
                    data={new Array(4).fill(undefined)}
                    loading={true}
                    noRecords=""
                  />
                </div>
              ) : (
                <LabelList
                  data={customerLabels}
                  noRecords="No customer labels found."
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SelectedBookingLabels;
